// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slider_wrapper__3NrEd","slide":"slider_slide__1e3pU"};